import { type ReactNode } from 'react';

import styles from './ResponsiveLayout.module.css';

interface Props {
  children: ReactNode;
  className?: string;
  header: ReactNode;
  testid?: string;
  scrollRef?: React.RefObject<HTMLDivElement>;
}

export function ResponsiveLayout({
  header,
  testid,
  children,
  className,
  scrollRef,
}: Props) {
  return (
    <div
      className={`${styles.form} ${className}`}
      data-testid={testid}
      ref={scrollRef}
    >
      {header}
      {children}
    </div>
  );
}
